import { createRouter, createWebHashHistory } from "vue-router";
import HelloWorld from "./components/HelloWorld.vue";
import LoginPage from "./components/LoginPage.vue";
import ChatPage from "./components/ChatPage.vue";
import ImportXlsx from "./components/ImportXlsx.vue";
import ImportXlsxID from "./components/ImportXlsxID.vue";
import TaskManager from "./components/TaskManager.vue";
import TaskDetailManager from "./components/TaskDetailManager.vue";
const routes = [
  {
    path: "/",
    redirect: "/login", // 重定向到登录页
  },
  {
    path: "/login", // 更明确的路径名
    name: "Login", // 更明确的路由名
    component: LoginPage,
  },
  {
    path: "/chat",
    name: "Chat",
    component: ChatPage,
    meta: {
      requiresAuth: true, // 需要登录才能访问
    },
  },
  {
    path: "/import-xlsx",
    name: "ImportXlsx",
    component: ImportXlsx,
  },
  {
    path: "/import-xlsxID",
    name: "ImportXlsxID",
    component: ImportXlsxID,
  },
  {
    path: "/task-manager",
    name: "TaskManager",
    component: TaskManager,
  },
  {
    path: "/task-detail-manager",
    name: "TaskDetailManager",
    component: TaskDetailManager,
  },
  // {
  // 	path: "/home", // 小写路径更符合常规
  // 	name: "Home",
  // 	component: HelloWorld,
  // },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 路由守卫，检查登录状态
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    // 这里需要根据你的实际情况来判断用户是否已登录
    const isAuthenticated = localStorage.getItem("isLoggedIn") === "true";

    if (!isAuthenticated) {
      next("/");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
